import { render, staticRenderFns } from "./AscPlotToIssuesGrid.vue?vue&type=template&id=40db0089&"
import script from "./AscPlotToIssuesGrid.vue?vue&type=script&lang=js&"
export * from "./AscPlotToIssuesGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotToIssuesGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports